import type { FaireProductEntity } from "../../entity_types/product";

export const p_qa248xyjw6: FaireProductEntity = {
  token: "p_qa248xyjw6",
  type: "product",
  name: "Cute Cat Gel Pen with Comfortable Grip",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/de23a4c6613108401b2a81b12683bf8cbc374adc22618e6327e9dad92500c09d.jpeg",
  priceDollars: 0.4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
